module.exports = __webpack_public_path__ + "static/img/thumbnail-large.490f132.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/thumbnail-large.jpg
// module id = K88u
// module chunks = 1